import jQuery from "jquery";
import "bootstrap";

const $ = jQuery;
window.$ = $;

// Init bootstrap scripts
$(document).ready(function() {

    // Tooltip
    $("body").tooltip({ selector: "[data-toggle=tooltip]", trigger:'hover' });

    // Tabs
    $(".nav-tabs a").on("click", function() {
        $(this).tab("show");
    });
});
